import { __commonJSMin as e } from "./index2.js";
import { require_react_is_production as t } from "./index24.js";
import { require_react_is_development as n } from "./index25.js";
//#region ../../node_modules/.pnpm/react-is@19.2.4/node_modules/react-is/index.js
var r = /* @__PURE__ */ e(((e, r) => {
	process.env.NODE_ENV === "production" ? r.exports = t() : r.exports = n();
}));
//#endregion
export default r();
export { r as require_react_is };

//# sourceMappingURL=index26.js.map